var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import videojs from 'video.js';
import { StyleSheet } from 'aphrodite';
import { bind } from 'bind-decorator';
import { observable, makeObservable } from 'mobx';
import { observer } from 'mobx-react';
import { ZIndex } from '../../constants';
import { LabelSwitchButton } from '../../molecules/label_switch_button';
import { MediaBreakPointUp } from '../../styles';
const AutoPlayButton = observer(class AutoPlayButton extends React.Component {
    render() {
        const label = `自動再生${this.props.vm.isAutoPlayNextVideo ? 'ON' : 'OFF'}`;
        return (React.createElement("div", { className: "vjs-auto-play-button" },
            React.createElement(LabelSwitchButton, { classObject: styles.autoPlaySetting, label: label, onClick: this.props.onSwitchIsAutoPlay, isOn: this.props.vm.isAutoPlayNextVideo })));
    }
});
class VjsAutoPlayButtonVM {
    constructor() {
        Object.defineProperty(this, "isAutoPlayNextVideo", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        makeObservable(this, {
            isAutoPlayNextVideo: observable,
        });
    }
}
export default class VjsAutoPlayButton extends videojs.getComponent('Component') {
    constructor(player, options) {
        super(player, options);
        Object.defineProperty(this, "autoPlayButtonOptions", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "autoPlayButtonPlayer", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "vm", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        this.autoPlayButtonOptions = options;
        this.autoPlayButtonPlayer = player;
        this.vm = new VjsAutoPlayButtonVM();
        this.fetchIsAutoPlay();
        this.mount = this.mount.bind(this);
        this.autoPlayButtonPlayer.ready(() => {
            this.mount();
        });
    }
    onSwitchIsAutoPlay() {
        return __awaiter(this, void 0, void 0, function* () {
            this.autoPlayButtonOptions.apiClient.UpdateViewingSetting(!this.vm.isAutoPlayNextVideo);
            this.setIsAutoPlay(!this.vm.isAutoPlayNextVideo);
        });
    }
    fetchIsAutoPlay() {
        return __awaiter(this, void 0, void 0, function* () {
            const profile = yield this.autoPlayButtonOptions.apiClient.fetchMypageProfile();
            this.setIsAutoPlay(profile.isAutoPlayNextVideo);
        });
    }
    setIsAutoPlay(isAutoPlay) {
        if (this.autoPlayButtonPlayer.isDisposed())
            return null;
        this.vm.isAutoPlayNextVideo = isAutoPlay;
        const result = this.autoPlayButtonPlayer.getChild('VjsResult');
        result.videoResultOptions.resultOptions.vm.setIsAutoPlay(isAutoPlay);
    }
    mount() {
        const root = ReactDOM.createRoot(this.el());
        root.render(React.createElement(AutoPlayButton, { vm: this.vm, onSwitchIsAutoPlay: this.onSwitchIsAutoPlay }));
    }
}
__decorate([
    bind
], VjsAutoPlayButton.prototype, "onSwitchIsAutoPlay", null);
__decorate([
    bind
], VjsAutoPlayButton.prototype, "fetchIsAutoPlay", null);
__decorate([
    bind
], VjsAutoPlayButton.prototype, "setIsAutoPlay", null);
const styles = StyleSheet.create({
    autoPlaySetting: {
        position: 'absolute',
        display: 'flex',
        flexDirection: 'row',
        top: 16,
        right: 16,
        zIndex: ZIndex.VideoPlayButton,
        [MediaBreakPointUp.MD]: {
            right: 24,
        },
    },
});
